<template>
  <transition name="modal">
    <div v-if="show" class="modal-mask" @click="$emit('close')">
      <div class="close">
        <button @click="$emit('close')">X</button>
      </div>
      <div class="modal-wrapper">
        <div class="modal-container">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="less">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .close {
    display: none;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10000;

    button {
      background: transparent;
      border: none;
      color: white;
      font-size: 1.5rem;
      cursor: pointer;

      &:hover {
        color: #ccc;
      }
    }
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    height: 100%;

    .modal-container {
      height: 100%;
      margin: 0 300px;
      overflow: hidden;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
    }
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 1024px) {
  .modal-mask {
    .close {
      display: unset;
    }

    .modal-wrapper .modal-container {
      margin: 0 10px;
      padding: 10% 20px;
    }
  }
}
</style>
